// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"ad52cde6","703":"56adc729","787":"1756ef0a"}[chunkId] + ".chunk.js";
};